import { openBankAccountDrawer, openLegalNameDrawer } from "@components/utils/OnboardingDrawer/utils";
import { envConfig } from "@configs/env";
import useAuthSession from "@hooks/useAuthSession";
import { DeployCountry } from "@types";
import { useCallback } from "react";
import { closeDeposit, openDeposit } from "../utils";

const IS_REQUIRE_BANK_ACCOUNT = envConfig.countryCode === DeployCountry.TH;
const IS_REQUIRE_LEGAL_NAME = envConfig.countryCode === DeployCountry.PH;

/**
 * Control the state of the deposit drawer with bank account verification
 */
export const useDepositDrawer = () => {
  const { bankAccount, legalName } = useAuthSession();

  const openDepositDrawer = useCallback(() => {
    // if require bank account, open bank account form
    if (IS_REQUIRE_BANK_ACCOUNT) {
      // if user did not have bank account, open bank account form
      if (!bankAccount) {
        openBankAccountDrawer(() => {
          // open deposit drawer after bank account form is completed
          openDeposit();
        });
        return;
      }
    }

    // if require legal name, open legal name form
    if (IS_REQUIRE_LEGAL_NAME) {
      // if user did not have legal name, open legal name form
      if (!legalName) {
        openLegalNameDrawer(() => {
          // open deposit drawer after legal name form is completed
          openDeposit();
        });
        return;
      }
    }

    openDeposit();
  }, [bankAccount, legalName]);

  const closeDepositDrawer = useCallback(() => {
    closeDeposit();
  }, []);

  return {
    openDepositDrawer,
    closeDepositDrawer,
  };
};
